import React from "react";
import WarningRouter from './Warning/Router';
export { getFields, getReplyFields } from './Warning/Router';

export default function EarlyWarningPmRouter(props){
    return <WarningRouter {...props} mode='PM' />;
}